const branding = {
  platformName: "EduVerse",
  appName: "ChemMaster SA",
  tagline: "Graad 12 Chemie. Slimmer leer. Sterker presteer.",
  primaryColor: "#2563eb",
  secondaryColor: "#f3f6fb",
  
};

export default branding;
